const DollarIcon = function DollarIcon() {
  return (
    <svg
      className="fin-state"
      width="27px"
      height="22px"
      viewBox="0 0 27 22"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>User Account</title>
      <g id="Dev-Ready-prototype" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Company_Financials" transform="translate(-1009.000000, -1583.000000)" fill="#3F4B50" fillRule="nonzero">
          <g id="Group-6" transform="translate(175.000000, 881.000000)">
            <g id="folder_black_24dp" transform="translate(831.364244, 697.000000)">
              <path d="M12.2266667,8 L14.8933333,10.6666667 L26.6666667,10.6666667 L26.6666667,24 L5.33333333,24 L5.33333333,8 L12.2266667,8 M13.3333333,5.33333333 L5.33333333,5.33333333 C3.86666667,5.33333333 2.68,6.53333333 2.68,8 L2.66666667,24 C2.66666667,25.4666667 3.86666667,26.6666667 5.33333333,26.6666667 L26.6666667,26.6666667 C28.1333333,26.6666667 29.3333333,25.4666667 29.3333333,24 L29.3333333,10.6666667 C29.3333333,9.2 28.1333333,8 26.6666667,8 L16,8 L13.3333333,5.33333333 Z" id="Shape" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default DollarIcon;
